import React, { useState } from 'react'
import { getMessage } from '../../../lib/translator'
import { TABLE_ACTIONS } from '../../../containers/ListingPage'
import AddDomainsModal from './AddDomainsModal'

export default function WhitelistDomainHeaderActions({ onAction, _data }) {
  const [modalOpen, setModalOpen] = useState(false)

  const handleOpenModal = () => {
    setModalOpen(true)
  }

  const handleSuccess = () => {
    if (onAction) {
      onAction(TABLE_ACTIONS.REFRESH)
    }
  }

  return (
    <>
      <button
        type="button"
        className="primary button"
        onClick={handleOpenModal}
        data-testid="add-domains-button"
      >
        + {getMessage('whitelistDomain.addDomains.button')}
      </button>
      <AddDomainsModal
        show={modalOpen}
        onClose={() => setModalOpen(false)}
        onSuccess={handleSuccess}
      />
    </>
  )
}
